import DashboardStats from "../../features/dashboard/stats/DashboardStats";

function Dashboard() {
    return <DashboardStats />
}

export default Dashboard